import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const CohortNameComponent = (props) => {
  return (
    <Box 
      sx={{
        minHeight: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: "1rem", md: "2rem" },
        width: "100%",
      }}
    >
      <Grid container spacing={3} maxWidth="600px">
        <Grid item xs={12}>
          <Typography 
            variant="h6" 
            sx={{ fontWeight: 500, marginBottom: "0.5rem" }}
          >
            Cohort Name <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            variant="standard"
            label="Enter Cohort Name"
            value={props.cohortName}
            onChange={props.handleCohortNameChange}
            autoComplete="off"
            InputProps={{
              sx: {
                "&:before": { borderBottomColor: "#14AE78" },
                "&:after": { borderBottomColor: "#14AE78" },
              }
            }}
          />
          {props.errors.cohortName && (
            <Typography 
              variant="body2" 
              color="error" 
              sx={{ marginTop: "0.5rem" }}
            >
              {props.errors.cohortName}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CohortNameComponent;
